__turbopack_context__.v({
  "container": "Ek-TVq_container",
  "name": "Ek-TVq_name",
  "photoWrap": "Ek-TVq_photoWrap",
  "post": "Ek-TVq_post",
});
